import { ADD_LOAD, CLEAR_LOAD, IS_HOME, IS_NOT_HOME, SET_CALENDARIO, SET_VERSAO } from '../actions/actionTypes';

const initialState = {
    loaded: false,
    isHome: false,
    versaoDate: '',
    calendario: '',
};

export const loadReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_LOAD: 
            return {...state, loaded: true, date: action.data};
        case CLEAR_LOAD: 
            return {...state, loaded: false}
        case IS_HOME: 
            return {...state, isHome: true}
        case IS_NOT_HOME: 
            return {...state, isHome: false}
        case SET_VERSAO: 
            return {...state, versaoDate: action.payload}
        case SET_CALENDARIO: 
            return {...state, calendario: action.payload}
        default:
            return state;
    }
};
